export default "__VITE_ASSET__656b18f7__"